// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"03b96cda","450":"4ac710a7"}[chunkId] + ".chunk.js";
};